export interface IDeckLayerEvents {
  click: any;
  hover: any;
}
